export default {
  // apiServerUrl: 'https://szwalnia.the-dev.org/',
  apiServerUrl: 'https://smpro.headwear.com.pl/',
  useConfig: 'prod',
  isSMPRO: true,
  additionalConfig: {
    'prod': {
      hplUrl: 'https://headwear.thecamels.pl/'
    },
    'dev': {
      hplUrl: 'https://headwear2.the-dev.org/'
    }
  }
};
